import React from 'react';
import { LucideIcon, ArrowUpRight } from 'lucide-react';
import Link from 'next/link';
import MiniChart from './MiniChart';

interface SchoolCardProps {
    id: string;
    name: string;
    income: string;
    expense: string;
    balance: string;
    color: string;
    icon: LucideIcon;
    chartData?: any[];
}

export default function SchoolCard({ id, name, income, expense, balance, color, icon: Icon }: SchoolCardProps) {
    return (
        <Link
            href={`/yayasan/${id}`}
            className="bg-surface border-2 border-border-main p-6 rounded-4xl hover:border-primary hover:shadow-2xl hover:shadow-primary/10 transition-all group"
        >
            <div className="flex items-center justify-between mb-6">
                <div className="flex items-center gap-4">
                    <div className={`w-14 h-14 ${color} rounded-2xl flex items-center justify-center shadow-sm group-hover:rotate-6 transition-transform`}>
                        <Icon className="w-7 h-7" />
                    </div>
                    <div>
                        <h4 className="font-bold text-foreground text-lg group-hover:text-primary transition-colors">{name}</h4>
                        <div className="flex items-center gap-1.5">
                            <span className="w-2 h-2 rounded-full bg-success animate-pulse"></span>
                            <p className="text-[10px] text-secondary font-bold uppercase tracking-wider">Connected</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="bg-background rounded-4xl p-5 grid grid-cols-3 gap-4 border border-border-main/50">
                <div className="text-center">
                    <p className="text-[10px] uppercase font-bold text-muted tracking-widest mb-1.5">Pemasukan</p>
                    <p className="text-sm font-bold text-foreground whitespace-nowrap">{income}</p>
                </div>
                <div className="text-center border-x border-border-main">
                    <p className="text-[10px] uppercase font-bold text-muted tracking-widest mb-1.5">Pengeluaran</p>
                    <p className="text-sm font-bold text-error whitespace-nowrap">{expense}</p>
                </div>
                <div className="text-center">
                    <p className="text-[10px] uppercase font-bold text-muted tracking-widest mb-1.5">Saldo</p>
                    <p className="text-sm font-bold text-primary whitespace-nowrap">{balance}</p>
                </div>
            </div>
        </Link>
    );
}


